import React from 'react';
import { Box, Button, createStyles, IconButton, makeStyles, MenuItem, TextField, Typography, } from '@material-ui/core';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { getPluginGuids, SecretType } from '@/entities/system';
import { ConfirmDeleteSystem } from '../../services/delete-system';
import { SystemFields } from '../SystemFields';
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '800px',
        padding: '72px',
    },
    header: {
        fontWeight: 600,
        marginBottom: '32px',
    },
    subheader: {
        fontWeight: 600,
        marginTop: '16px',
        marginBottom: '16px',
    },
    input: {
        width: '370px',
        marginBottom: '16px',
    },
    secretRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
    },
    secretType: {
        width: '190px',
        marginRight: '16px',
    },
    secretValue: {
        width: '370px',
    },
    addSecret: {
        marginBottom: '32px',
    },
}));
export const FormEdit = ({ updatingSystem, onSubmit, system, options, onDelete }) => {
    const styles = useStyles();
    const { register, control, handleSubmit, watch } = useForm({
        defaultValues: {
            description: system.description,
            serializationPluginGuids: getPluginGuids(system.serializationPluginsInfo),
            integrationPluginGuids: getPluginGuids(system.integrationPluginsInfo),
            objectServePluginGuids: getPluginGuids(system.objectServePluginsInfo),
            asyncIntegrationPluginGuids: getPluginGuids(system.asyncIntegrationPluginsInfo),
            pluginInstanceGuid: system.agentInfo?.guid ?? '',
            updateSystemSecrets: (system.huHeadSecretInfos ?? []).map((secret) => ({
                guid: secret.guid,
                secretType: secret.type,
                value: secret.value,
            })),
        },
    });
    const { fields, append, remove } = useFieldArray({ control, name: 'updateSystemSecrets' });
    const readOnlyRows = [
        { label: 'Код', value: system.code },
        { label: 'Идентификатор', value: system.guid },
    ];
    const handleFormSubmit = ({ updateSystemSecrets, ...systemFields }) => {
        onSubmit({
            ...systemFields,
            guid: system.guid,
            code: system.code,
            updateSystemSecrets: (updateSystemSecrets ?? []).map((secret) => ({
                guid: secret.guid || null,
                secretType: Number(secret.secretType),
                value: secret.value,
            })),
        });
    };
    return (React.createElement("form", { className: styles.root, noValidate: true, autoComplete: "off", onSubmit: handleSubmit(handleFormSubmit) },
        React.createElement(Typography, { className: styles.header, variant: "h4", component: "h2" }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u044B"),
        readOnlyRows.map(({ label, value }) => (React.createElement(TextField, { key: label, className: styles.input, variant: "outlined", label: label, value: value || '—', InputProps: { readOnly: true }, InputLabelProps: { shrink: true } }))),
        React.createElement(TextField, { className: styles.input, variant: "outlined", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", required: true, name: "description", defaultValue: system.description, inputRef: register({ required: true }) }),
        React.createElement(SystemFields, { control: control, options: options, className: styles.input }),
        React.createElement(Typography, { className: styles.subheader, variant: "h6", component: "h3" }, "\u0421\u0435\u043A\u0440\u0435\u0442\u044B"),
        fields.map((item, index) => (React.createElement("div", { className: styles.secretRow, key: item.id },
            React.createElement("input", { type: "hidden", name: `updateSystemSecrets[${index}].guid`, defaultValue: item.guid ?? '', ref: register() }),
            React.createElement(Controller, { as: React.createElement(TextField, { className: styles.secretType, label: "\u0422\u0438\u043F", required: true, select: true, variant: "outlined" },
                    React.createElement(MenuItem, { value: SecretType.LOGIN }, "\u041B\u043E\u0433\u0438\u043D"),
                    React.createElement(MenuItem, { value: SecretType.PASSWORD }, "\u041F\u0430\u0440\u043E\u043B\u044C"),
                    React.createElement(MenuItem, { value: SecretType.TOKEN }, "\u0422\u043E\u043A\u0435\u043D"),
                    React.createElement(MenuItem, { value: SecretType.SERVER }, "\u0421\u0435\u0440\u0432\u0435\u0440"),
                    React.createElement(MenuItem, { value: SecretType.DATABASE_NAME }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0411\u0414"),
                    React.createElement(MenuItem, { value: SecretType.HOST }, "\u0425\u043E\u0441\u0442"),
                    React.createElement(MenuItem, { value: SecretType.PORT }, "\u041F\u043E\u0440\u0442")), name: `updateSystemSecrets[${index}].secretType`, control: control, defaultValue: item.secretType }),
            React.createElement(TextField, { type: Number(watch(`updateSystemSecrets[${index}].secretType`)) === SecretType.PASSWORD
                    ? 'password'
                    : 'text', className: styles.secretValue, variant: "outlined", label: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435", required: true, name: `updateSystemSecrets[${index}].value`, defaultValue: item.value, inputRef: register({
                    required: true,
                }) }),
            React.createElement(IconButton, { edge: "end", onClick: () => remove(index) },
                React.createElement(DeleteIcon, null))))),
        React.createElement(Button, { className: styles.addSecret, type: "button", variant: "outlined", color: "primary", startIcon: React.createElement(AddCircleIcon, null), onClick: () => append({ guid: '', secretType: SecretType.LOGIN, value: '' }) }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0435\u043A\u0440\u0435\u0442"),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Button, { type: "submit", variant: "contained", color: "primary", disabled: updatingSystem }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
            React.createElement(Box, { ml: 2 },
                React.createElement(ConfirmDeleteSystem, { disabled: updatingSystem, onDelete: () => onDelete(system.guid) })))));
};
